module.exports = __webpack_public_path__ + "img/bg.65bee935.jpg";